/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {
  const toggleBtn = document.getElementById('toggle-mobile-search');
  const searchContainer = document.getElementById('mobile-search-container');

  if (toggleBtn && searchContainer) {
    toggleBtn.addEventListener('click', function () {
      searchContainer.classList.toggle('d-none');
    });
  }
});


/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */
